(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.cartFlyout = document.querySelector('.js-cart__flyout-container');

      this.gameNavContainer = document.querySelector('.js-games-nav');
      this.productNavContainer = document.querySelector('.js-product-nav');
      this.announcementBar = document.getElementById('shopify-section-announcement-bar');
      this.mobileCategoryBar = document.querySelector('.mobile-category-bar-wrapper');

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
  // Ensure this.header is a valid Element
  if (!this.header || !(this.header instanceof Element)) {
    console.warn('Header element not found or invalid');
    return;
  }

  if (!('IntersectionObserver' in window)) {
    // Fallback for browsers without IntersectionObserver
    this.headerBounds = this.header.getBoundingClientRect();
    return;
  }

  let observer = new IntersectionObserver((entries, observer) => {
    if (entries[0]) {
      this.headerBounds = entries[0].intersectionRect;
    }
    observer.disconnect();
  });

  observer.observe(this.header);
}

    onScroll() {
      const cartFlyoutContainer = document.querySelector('.js-cart__flyout-container');

      if (cartFlyoutContainer && !cartFlyoutContainer.classList.contains('is-open')) {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (this.preventHide) return;
          requestAnimationFrame(this.hide.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          } else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        } else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }

        this.currentScrollTop = scrollTop;
      } else {
        if (this.headerWrapper && this.headerWrapper.classList.contains('with-cart-flyout')) {
          this.headerWrapper.classList.add('with-cart-flyout');
        }
      }
    }

    hide() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > 100) {
        this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
        this.header.classList.remove('with-announcement-bar');
        this.cartFlyout.classList.remove('with-announcement-bar');

        if (this.gameNavContainer) {
          this.gameNavContainer.classList.add('shopify-section-games-header-animate');
          this.gameNavContainer.classList.remove('with-announcement-bar');
        }

        if (this.productNavContainer) {
          this.productNavContainer.classList.add('shopify-section-product-header-animate');
          this.productNavContainer.classList.remove('with-announcement-bar');
        }

        if (this.announcementBar) {
          this.announcementBar.classList.add('shopify-section-header-hidden');
        }

        if (this.mobileCategoryBar) {
          this.mobileCategoryBar.classList.add('mobile-category-bar-hidden');
        }
      }

      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      if (this.gameNavContainer) {
        this.gameNavContainer.classList.remove('shopify-section-games-header-animate');
      }
      if (this.productNavContainer) {
        this.productNavContainer.classList.remove('shopify-section-product-header-animate');
      }

      if (this.gameNavContainer) {
        this.gameNavContainer.classList.remove('with-announcement-bar');
      }

      if (this.productNavContainer) {
        this.productNavContainer.classList.remove('with-announcement-bar');
      }

      if (this.announcementBar) {
        this.announcementBar.classList.add('shopify-section-header-hidden');
      }

      if (this.mobileCategoryBar) {
        this.mobileCategoryBar.classList.remove('mobile-category-bar-hidden');
      }
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      if (this.mobileCategoryBar) {
        this.mobileCategoryBar.classList.remove('mobile-category-bar-hidden');
      }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-additional-content"] && !Shopify.designMode) return;
  try {
    
  class ProductAdditionalRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        let url = this.dataset.url;

        fetch(url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            let recommendations = html.querySelector('product-additional-recommendations');
            const quickAdds = Array.from(html.querySelectorAll('.quick-add'));
            const quickAddColors = Array.from(html.querySelectorAll('.quick-add_colors'));

            if (quickAdds.length > 0) {
              quickAdds.forEach((el) => {
                el.classList.add('hidden');
              });
            }

            if (quickAddColors.length > 0) {
              quickAddColors.forEach((el) => {
                el.classList.add('hidden');
              });
            }

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch((e) => {
            console.error(e);
          });
      };

      // Add safety check
if (this instanceof Element && 'IntersectionObserver' in window) {
  new IntersectionObserver(handleIntersection.bind(this), { 
    rootMargin: '0px 0px 200px 0px' 
  }).observe(this);
} else {
  // Fallback: load immediately if no IO support
  handleIntersection([{ isIntersecting: true }], { unobserve: () => {} });
}
    }
  }

  customElements.define('product-additional-recommendations', ProductAdditionalRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        let url = this.dataset.url;

        fetch(url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            let recommendations = html.querySelector('product-recommendations');
            const quickAdds = Array.from(html.querySelectorAll('.quick-add'));
            const quickAddColors = Array.from(html.querySelectorAll('.quick-add_colors'));

            if (quickAdds.length > 0) {
              quickAdds.forEach((el) => {
                el.classList.add('hidden');
              });
            }

            if (quickAddColors.length > 0) {
              quickAddColors.forEach((el) => {
                el.classList.add('hidden');
              });
            }

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch((e) => {
            console.error(e);
          });
      };

      class ProductRecommendations extends HTMLElement {
  constructor() {
    super();

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      const url = this.dataset.url;
      if (!url) return;

      fetch(url)
        .then((response) => {
          if (!response.ok) throw new Error('Network error');
          return response.text();
        })
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            // Hide quick-add elements before inserting
            const quickAdds = recommendations.querySelectorAll('.quick-add, .quick-add_colors');
            quickAdds.forEach((el) => el.classList.add('hidden'));
            
            this.innerHTML = recommendations.innerHTML;
            
            if (this.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          }
        })
        .catch((e) => {
          console.error('Failed to load product recommendations:', e);
        });
    };

    // Safety check for IntersectionObserver
    if ('IntersectionObserver' in window && this instanceof Element) {
      new IntersectionObserver(handleIntersection.bind(this), { 
        rootMargin: '0px 0px 200px 0px' 
      }).observe(this);
    } else {
      // Fallback: load immediately if no IO support
      handleIntersection([{ isIntersecting: true }], { unobserve: () => {} });
    }
  }
}

customElements.define('product-recommendations', ProductRecommendations);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
